
import Vue, { defineComponent } from "vue";
export default defineComponent({
  name: "trendingStylesSvg",
  components: {},
  props: {
    color: {
      type: String,
      default: "red",
    },
  },
});
